/* global wpApiSettings */

// let $form;

// function init() {
//
// 	$form = $('.form--user');
//
// 	if (!$form.length) {
// 		return;
// 	}
//
// 	$form.on('submit', (event) => {
// 		event.preventDefault();
// 		handleFormSubmit(event);
// 	});
//
// }


function init() {

	$('.editlist__item-control[data-action="delete"]').on('click', (event) => {

		const $button = $(event.target);
		const itemType = $button.closest('.editlist').data('item-type');
		const itemId = $button.data('item-id');
		const message = {
			place: 'Haluatko varmasti poistaa kohteen?',
			story: 'Haluatko varmasti poistaa tarinan?'
		};

		if (window.confirm(message[itemType])) {

			$.ajax({
				url: `/wp-json/wp/v2/kylahistoria_${itemType}/${itemId}`,
				method: 'DELETE',
				processData: false,
				contentType: false,
				beforeSend: (xhr) => {
					// xhr.setRequestHeader('X-WP-Nonce', $form.find('[name="_wpnonce"]').val());
					// xhr.setRequestHeader('Authorization', `Basic ${btoa(username + ':' + password)}`);
					xhr.setRequestHeader('X-WP-Nonce', wpApiSettings.nonce);
				}
				// data: data
			})
			.done((data, textStatus, jqXHR) => {

				if (jqXHR.status === 200) {
					$button.closest('li').remove();
				}

			});

		}

	});

}

export default {
	init
};
